import classNames from 'classnames';
import s from './InputTel.module.scss';
import { ChangeEvent, useState } from 'react';
import CheckIcon from '@/shared/assets/icons/check.svg';
import WarningIcon from '@/shared/assets/icons/warning.svg';
import { IMaskInput } from 'react-imask';

interface InputTelProps {
  label?: string;
  className?: string;
  placeholder?: string;
  error: string;
  value: string;
  onChange: (e: ChangeEvent<HTMLInputElement> | string) => void;
  disabled?: boolean;
  isSubmitted?: boolean;
  baseAddon?: boolean;
  onBlur?: () => void;
  size?: 'default' | 'compact';
  inputId?: string;
  autoComplete?: string;
  name?: string;
}

export const InputTel = (props: InputTelProps) => {
  const {
    className,
    label,
    placeholder,
    error,
    value = '',
    onChange,
    disabled,
    isSubmitted,
    baseAddon = true,
    onBlur,
    size = 'default',
    inputId,
    autoComplete = 'off',
    name = 'phone',
  } = props;

  const [focus, setFocus] = useState(false);

  const mods = {
    [s.disabled]: disabled,
    [s.isError]: !!error,
    [s.compact]: size === 'compact',
  };

  const wrapperClass = classNames(s.wrapper, { [s.compactWrapper]: size === 'compact' });
  const inputClass = classNames(
    s.input,
    {
      [s.baseAddon]: baseAddon,
      [s.compactInput]: size === 'compact',
    },
    [className],
  );
  const statusClass = classNames(s.status, { [s.compactStatus]: size === 'compact' });

  return (
    <div className={classNames(s.Input, mods, [className])}>
      {label && (
        <label className={s.label} htmlFor={inputId ?? label}>
          {label}
        </label>
      )}
      <div className={wrapperClass}>
        <IMaskInput
          className={inputClass}
          onFocus={() => setFocus(true)}
          onBlur={() => {
            setFocus(false);
            onBlur?.();
          }}
          value={value}
          overwrite={true}
          mask={'+7 000-000-00-00'}
          autofix={'pad'}
          onAccept={(value) => onChange(value)}
          placeholder={placeholder}
          type={'tel'}
          disabled={disabled}
          name={name}
          id={(inputId ?? label) || undefined}
          lazy={!focus}
          autoComplete={autoComplete}
        />
        {baseAddon && isSubmitted && (
          <div className={statusClass}>
            {error ? <WarningIcon className={s.warning} /> : <CheckIcon className={s.check} />}
          </div>
        )}
      </div>
      {error && error.trim().length > 0 && <span className={s.error}>{error}</span>}
    </div>
  );
};
